import { t as __t } from "i18next";
import React, { useEffect, useRef, useState } from "react";
import { notifyListRefresh } from "../../../utils/listNavigation";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AsyncPaginate } from "react-select-async-paginate";
import DatePicker from "react-datepicker";
import moment from "moment";

import {
	callGetAllProvince,
	callGetDistrict,
	callGetVehicleBrand,
	callUploadFile,
} from "../../../api/settings/service";
import {
	addVehicleCaseIdioms,
	callGetContractByKey,
	callgetVehicleCaseIdiomsById,
	updateVehicleCaseIdioms,
} from "../../../api/contract/service";

import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import BackPrevious from "../../../components/back-previous";
import DataAutoComplete from "../../../components/auto-complete";
import SwalAlert from "../../../components/common/alert";
import FileUploadGrid from "../../../components/upload-file";

import "../../../components/i18n/lang";
import "react-datepicker/dist/react-datepicker.css";
import "./index.css";

import {
	decodeBase64,
	convertStringToJson,
} from "../../../utils/commonUtil";

const createThirdPartyVehicle = () => ({
	id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
	contactNumber: "",
	vehicleBrand: null,
	vehicleBrandId: "",
	vehicleModel: "",
	licensePlate: "",
	insurance: "",
});

const safeJsonArray = (value) => {
	if (!value) return [];

	if (Array.isArray(value)) return value;

	try {
		const result =
			typeof value === "string" ? convertStringToJson(value) : value;

		return Array.isArray(result) ? result : [];
	} catch (error) {
		return [];
	}
};

const toDateOrNull = (value) => {
	if (!value) return null;

	if (value instanceof Date && !Number.isNaN(value.getTime())) {
		return value;
	}

	const date = new Date(String(value).replace("Z", ""));
	return Number.isNaN(date.getTime()) ? null : date;
};

const Index = () => {
	const userInfo = useSelector((state) => state.dataLogin);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const params = useParams();
	const { t } = useTranslation();

	const saveButtonRef = useRef(null);

	const [contractList, setContractList] = useState([]);
	const [contractNumber, setContractNumber] = useState(null);
	const [provinceList, setProvinceList] = useState([]);
	const [districtList, setDistrictList] = useState([]);
	const [isStickyVisible, setStickyVisible] = useState(false);
	const [isSaving, setIsSaving] = useState(false);

	const [request, setRequest] = useState({
		id: null,
		contractNo: "",
		caseIdiomsCode: "",

		provinceId: "",
		districtId: "",
		village: "",

		accidentDate: null,
		reportAtAccidentDate: null,
		reportAtAccidentName: "",
		reportToPhone: "",
		personCase: "",

		driverAccidentName: "",
		contactNumber: "",

		thirdPartyVehicles: [createThirdPartyVehicle()],

		accidentNote: "",
		description: "",

		accidentImages: [],
		documentPath: [],
		accidentImagesFile: { file: null },
		documentPathFile: { file: null },

		carriredCode: "",
		carriredName: "",
		vehicleInfo: null,
	});

	const getCarrierInfo = () => {
		const user = userInfo?.data?.user;

		return {
			carriredCode: user?.userId || "",
			modifiedCode: user?.userId || "",
			modifiedName: [user?.firstName, user?.lastName]
				.filter(Boolean)
				.join(" "),
			carriredName: [user?.firstName, user?.lastName]
				.filter(Boolean)
				.join(" "),
		};
	};

	const loadProvince = async () => {
		const response = await dispatch(callGetAllProvince());

		if (response?.payload?.responseCode === "00000") {
			setProvinceList(response?.payload?.data || []);
		}
	};

	const loadDistrict = async (provinceId) => {
		if (!provinceId) {
			setDistrictList([]);
			return;
		}

		const response = await dispatch(
			callGetDistrict({
				provinceId,
			})
		);

		if (response?.payload?.responseCode === "00000") {
			setDistrictList(response?.payload?.data || []);
		} else {
			setDistrictList([]);
		}
	};

	const loadVehicleBrand = async (
		search,
		loadedOptions,
		additional = { page: 1 }
	) => {
		const page = additional?.page || 1;

		const response = await dispatch(
			callGetVehicleBrand({
				page,
				maxResult: 10,
				keyword: search,
			})
		);

		if (response?.payload?.responseCode !== "00000") {
			return {
				options: [],
				hasMore: false,
				additional: { page: page + 1 },
			};
		}

		const result = response?.payload?.data?.result || [];
		const totalRecords =
			Number(response?.payload?.data?.totalRecords) || 0;

		return {
			options: result.map((item) => ({
				value: item.brandId,
				label: item.brandNameEn || item.brandNameLo || item.brandName,
			})),
			hasMore: loadedOptions.length + result.length < totalRecords,
			additional: {
				page: page + 1,
			},
		};
	};

	const normalizeThirdPartyVehicles = (data) => {
		const list = safeJsonArray(data?.thirdPartyVehicles);

		if (list.length > 0) {
			return list.map((item) => ({
				id:
					item.id ||
					`${Date.now()}-${Math.random().toString(36).slice(2)}`,
				contactNumber:
					item.contactNumber ||
					item.thridPartyContactNumber ||
					"",
				vehicleBrand: item.vehicleBrandId
					? {
						value: item.vehicleBrandId,
						label:
							item.vehicleBrandName ||
							item.vehicleBrand?.label ||
							"",
					}
					: item.vehicleBrand || null,
				vehicleBrandId:
					item.vehicleBrandId ||
					item.thirdPartyVehicleBrandId ||
					"",
				vehicleModel:
					item.vehicleModel ||
					item.thirdPartyVehicleModel ||
					"",
				licensePlate:
					item.licensePlate ||
					item.thirdPartyLicensePlate ||
					"",
				insurance:
					item.insurance ||
					item.thirdPartyInsurance ||
					"",
			}));
		}
		const hasLegacyVehicle =
			data?.thridPartyContactNumber ||
			data?.thirdPartyVehicleBrandId ||
			data?.thirdPartyVehicleModel ||
			data?.thirdPartyLicensePlate;

		if (hasLegacyVehicle) {
			return [
				{
					...createThirdPartyVehicle(),
					contactNumber: data?.thridPartyContactNumber || "",
					vehicleBrand: data?.thirdPartyVehicleBrandId
						? {
							value: data.thirdPartyVehicleBrandId,
							label:
								data.thirdPartyVehicleBrandName ||
								data.thirdPartyVehicleBrand ||
								"",
						}
						: null,
					vehicleBrandId:
						data?.thirdPartyVehicleBrandId || "",
					vehicleModel:
						data?.thirdPartyVehicleModel || "",
					licensePlate:
						data?.thirdPartyLicensePlate || "",
					insurance: ""
				},
			];
		}

		return [createThirdPartyVehicle()];
	};

	const loadInitialData = async (id) => {
		const response = await dispatch(
			callgetVehicleCaseIdiomsById({
				idiomsId: id,
			})
		);
		console.log(response?.payload?.data)
		if (response?.payload?.responseCode !== "00000") {
			SwalAlert.error(
				__t("uiText.text023"),
				response?.payload?.responseDescription || __t("uiText.text032")
			);
			return;
		}

		const data = response?.payload?.data || {};

		if (data?.provinceId) {
			await loadDistrict(data.provinceId);
		}

		setContractNumber({
			id: data.contractNo,
			contractNumber: data.contractNo,
			label: data.fullName || data.customerName || data.contractNo,
		});

		setRequest((prev) => ({
			...prev,
			...data,
			id,
			accidentDate: toDateOrNull(data.accidentDate),
			reportAtAccidentDate: toDateOrNull(
				data.reportAtAccidentDate
			),
			accidentImages: safeJsonArray(data.accidentImages),
			documentPath: safeJsonArray(data.documentPath),
			thirdPartyVehicles: normalizeThirdPartyVehicles(data),
			vehicleInfo:
				data.vehicleInfo ||
				{
					brandName: data.brandName || "",
					vehicleModel: data.vehicleModel || "",
					licensePlate: data.licensePlate || "",
				},
		}));
	};

	const preselectContractFromClaimCenter = async (contractNo) => {
		if (!contractNo || params?.id) return;

		const response = await dispatch(
			callGetContractByKey({
				keyword: contractNo,
				page: 1,
				maxResult: 10,
				insuranceType: 2,
			})
		);

		if (response?.payload?.responseCode !== "00000") return;

		const rows = response?.payload?.data?.result || [];
		const selected =
			rows.find((item) => item?.contractNumber === contractNo) || rows[0];

		setContractList(rows);
		if (selected) {
			setContractNumber({
				...selected,
				id: selected.contractNumber,
				contractNumber: selected.contractNumber,
				label: selected.fullName || selected.label || selected.contractNumber,
			});
			setRequest((prev) => ({
				...prev,
				vehicleInfo: selected,
				contractNo: selected.contractNumber || contractNo,
			}));
		}
	};

	useEffect(() => {
		loadProvince();

		const carrierInfo = getCarrierInfo();

		setRequest((prev) => ({
			...prev,
			...carrierInfo,
		}));

		if (params?.id) {
			const decodedId = decodeBase64(params.id);
			console.log(decodedId)
			if (decodedId != null) {
				loadInitialData(decodedId);
			}
		} else if (location.state?.contractNumber) {
			preselectContractFromClaimCenter(location.state.contractNumber);
		}

		const handleScroll = () => {
			if (!saveButtonRef.current) return;

			const rect = saveButtonRef.current.getBoundingClientRect();
			setStickyVisible(rect.top > window.innerHeight || rect.bottom < 0);
		};

		window.addEventListener("scroll", handleScroll);
		handleScroll();

		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleChange = (event) => {
		const { name, value } = event.target;

		setRequest((prev) => ({
			...prev,
			[name]: value,
			...(name === "provinceId" ? { districtId: "" } : {}),
		}));

		if (name === "provinceId") {
			loadDistrict(value);
		}
	};

	const handleDateChange = (date, field) => {
		setRequest((prev) => ({
			...prev,
			[field]: date || null,
		}));
	};

	const handleFileSelect = (file, field) => {
		setRequest((prev) => ({
			...prev,
			[field]: {
				file: file || null,
			},
		}));
	};

	const addThirdPartyVehicle = () => {
		setRequest((prev) => ({
			...prev,
			thirdPartyVehicles: [
				...prev.thirdPartyVehicles,
				createThirdPartyVehicle(),
			],
		}));
	};

	const removeThirdPartyVehicle = (index) => {
		setRequest((prev) => {
			const nextVehicles = prev.thirdPartyVehicles.filter(
				(_, itemIndex) => itemIndex !== index
			);

			return {
				...prev,
				thirdPartyVehicles:
					nextVehicles.length > 0
						? nextVehicles
						: [createThirdPartyVehicle()],
			};
		});
	};

	const updateThirdPartyVehicle = (index, field, value) => {
		setRequest((prev) => ({
			...prev,
			thirdPartyVehicles: prev.thirdPartyVehicles.map(
				(vehicle, itemIndex) =>
					itemIndex === index
						? {
							...vehicle,
							[field]: value,
						}
						: vehicle
			),
		}));
	};

	const handleThirdPartyBrandChange = (index, option) => {
		setRequest((prev) => ({
			...prev,
			thirdPartyVehicles: prev.thirdPartyVehicles.map(
				(vehicle, itemIndex) =>
					itemIndex === index
						? {
							...vehicle,
							vehicleBrand: option,
							vehicleBrandId: option?.value || "",
						}
						: vehicle
			),
		}));
	};

	const loadContractData = async (value) => {
		const keyword = value?.id || value || "";

		if (!keyword) {
			setContractList([]);
			return;
		}

		const response = await dispatch(
			callGetContractByKey({
				keyword,
				page: 1,
				maxResult: value?.id ? 1 : 10,
				insuranceType: 2,
			})
		);

		if (response?.payload?.responseCode === "00000") {
			setContractList(response?.payload?.data?.result || []);
		} else {
			setContractList([]);
		}
	};

	const onSelectContract = (item) => {
		setRequest((prev) => ({
			...prev,
			vehicleInfo: item || null,
			contractNo: item?.contractNumber || "",
		}));
	};

	const buildPayload = () => {
		const thirdPartyVehicles = request.thirdPartyVehicles.map(
			(vehicle, index) => ({
				order: index + 1,
				contactNumber: vehicle.contactNumber || "",
				vehicleBrandId: vehicle.vehicleBrandId || "",
				vehicleBrandName: vehicle.vehicleBrand?.label || "",
				vehicleModel: vehicle.vehicleModel || "",
				licensePlate: vehicle.licensePlate || "",
				insurance: vehicle.insurance || "",
			})
		);

		const firstVehicle = thirdPartyVehicles[0] || {};

		return {
			...request,
			accidentDate: request.accidentDate
				? moment(request.accidentDate).format(
					"YYYY-MM-DD HH:mm:ss"
				)
				: null,
			reportAtAccidentDate: request.reportAtAccidentDate
				? moment(request.reportAtAccidentDate).format(
					"YYYY-MM-DD HH:mm:ss"
				)
				: null,

			// New field for multiple third-party vehicles.
			thirdPartyVehicles,

			// Legacy fields for backward compatibility.
			thridPartyContactNumber:
				firstVehicle.contactNumber || "",
			thirdPartyVehicleBrandId:
				firstVehicle.vehicleBrandId || "",
			thirdPartyVehicleModel:
				firstVehicle.vehicleModel || "",
			thirdPartyLicensePlate:
				firstVehicle.licensePlate || "",
			thirdPartyVehicleBrand: undefined,
		};
	};

	const uploadSelectedFiles = async () => {
		let documentPath = request.documentPath;
		let accidentImages = request.accidentImages;

		if (request.documentPathFile?.file) {
			const uploadResponse = await dispatch(
				callUploadFile(request.documentPathFile.file)
			);

			if (uploadResponse?.payload?.responseCode !== "00000") {
				throw new Error(t("uploadFile.documentPathFile"));
			}

			documentPath = uploadResponse?.payload?.data || [];
		}

		if (request.accidentImagesFile?.file) {
			const uploadResponse = await dispatch(
				callUploadFile(request.accidentImagesFile.file)
			);

			if (uploadResponse?.payload?.responseCode !== "00000") {
				throw new Error(t("uploadFile.accidentImagesFile"));
			}

			accidentImages = uploadResponse?.payload?.data || [];
		}

		return {
			documentPath,
			accidentImages,
		};
	};

	const validateForm = () => {
		if (!request.contractNo) {
			SwalAlert.error(
				__t("uiText.text019"),
				__t("uiText.text180")
			);
			return false;
		}

		if (!request.accidentDate || !request.reportAtAccidentDate) {
			SwalAlert.error(
				__t("uiText.text019"),
				__t("uiText.text181")
			);
			return false;
		}

		return true;
	};

	const handleSave = async (event) => {
		event.preventDefault();

		if (!validateForm() || isSaving) return;
		console.log(buildPayload())
		SwalAlert.confirm(
			t("nameSave"),
			t("confirmSave"),
			async () => {
				try {
					setIsSaving(true);

					const uploadedFiles = await uploadSelectedFiles();
					const carrierInfo = getCarrierInfo();

					const payload = {
						...buildPayload(),
						...carrierInfo,
						documentPath: JSON.stringify(
							uploadedFiles.documentPath || []
						),
						accidentImages: JSON.stringify(
							uploadedFiles.accidentImages || []
						),

						// Use JSON.stringify here only when the API/database
						// stores this field as JSON text.
						thirdPartyVehicles: JSON.stringify(
							buildPayload().thirdPartyVehicles
						),
					};

					const response = request.id
						? await dispatch(
							updateVehicleCaseIdioms(payload)
						)
						: await dispatch(
							addVehicleCaseIdioms(payload)
						);

					if (
						response?.payload?.responseCode === "00000"
					) {
						notifyListRefresh();
						if (location.state?.returnToVehicleClaimCenter) {
							navigate(-1);
						} else {
							navigate("/admin/contractControl/caseStatement");
						}
						return;
					}

					SwalAlert.error(
						__t("uiText.text023"),
						`${response?.payload?.responseCode || ""} - ${response?.payload
							?.responseDescription ||
						__t("uiText.text182")
						}`
					);
				} catch (error) {
					SwalAlert.error(
						__t("uiText.text023"),
						error?.message || String(error)
					);
				} finally {
					setIsSaving(false);
				}
			}
		);
	};

	const selectStyles = {
		control: (base, state) => ({
			...base,
			minHeight: 48,
			borderRadius: 12,
			borderColor: state.isFocused
				? "var(--case-primary)"
				: "#dbe3ec",
			background: "#ffffff",
			boxShadow: state.isFocused
				? "0 0 0 3px rgba(42, 91, 215, 0.12)"
				: "none",
			"&:hover": {
				borderColor: "var(--case-primary)",
			},
		}),
		valueContainer: (base) => ({
			...base,
			padding: "0 14px",
			fontSize: 14,
		}),
		menuPortal: (base) => ({
			...base,
			zIndex: 9999,
		}),
	};

	return (
		<div className="page-wrapper dashboard case-idioms-page">
			<span className="header-span" />

			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />

			<form onSubmit={handleSave}>
				<section className="user-dashboard">
					<div className="dashboard-outer">
						<div className="case-page-header">
							<div className="case-page-header__left">
								<BackPrevious />

								<div>
									<span className="case-page-header__eyebrow">
										{__t("uiText.text423")}</span>

									<h3>
										{request.id
											? __t("uiText.text183")
											: __t("uiText.text184")}
									</h3>

									<p>
										{__t("uiText.text185")}</p>
								</div>
							</div>

							<div className="case-page-header__status">
								<span className="case-status-dot" />
								{request.id
									? __t("uiText.text186")
									: __t("uiText.text187")}
							</div>
						</div>

						<div className="case-form-layout">
							<main className="case-form-main">
								<section className="case-section">
									<div className="case-section__header">
										<div className="case-section__icon">
											<i className="fas fa-file-contract" />
										</div>

										<div>
											<h5>{__t("uiText.text188")}</h5>
											<p>
												{__t("uiText.text189")}</p>
										</div>
									</div>

									<div className="case-section__body">
										<div className="row g-3">
											<div className="col-lg-7">
												<label className="case-label">
													{t(
														"contracts.vehicle.contractCode"
													)}
													<span>*</span>
												</label>

												<DataAutoComplete
													disabled={
														request.id != null
													}
													label="label"
													id="id"
													initialData={
														contractNumber
													}
													data={contractList}
													autoSelect
													placeholder={t(
														"contract.keyword"
													)}
													handleChange={
														loadContractData
													}
													onSelect={
														onSelectContract
													}
												/>
											</div>

											<div className="col-lg-5">
												<label className="case-label">
													{t(
														"contracts.vehicle.caseIdiomsCode"
													)}
												</label>

												<input
													className="case-input"
													name="caseIdiomsCode"
													value={
														request.caseIdiomsCode ||
														""
													}
													onChange={handleChange}
													// readOnly={
													// 	request.id != null
													// }
													placeholder={__t("uiText.text190")}
												/>
											</div>
										</div>

										<div className="insured-vehicle-card">
											<div className="insured-vehicle-card__title">
												<i className="fas fa-car-side" />
												{__t("uiText.text191")}</div>

											<div className="insured-vehicle-grid">
												<div>
													<span>{__t("uiText.text192")}</span>
													<strong>
														{request
															?.vehicleInfo
															?.brandName ||
															"-"}
													</strong>
												</div>

												<div>
													<span>{__t("uiText.text193")}</span>
													<strong>
														{request
															?.vehicleInfo
															?.vehicleModel ||
															"-"}
													</strong>
												</div>

												<div>
													<span>{__t("uiText.text194")}</span>
													<strong>
														{request
															?.vehicleInfo
															?.licensePlate ||
															"-"}
													</strong>
												</div>
											</div>
										</div>
									</div>
								</section>

								<section className="case-section">
									<div className="case-section__header">
										<div className="case-section__icon">
											<i className="fas fa-map-marker-alt" />
										</div>

										<div>
											<h5>{__t("uiText.text195")}</h5>
											<p>
												{__t("uiText.text196")}</p>
										</div>
									</div>

									<div className="case-section__body">
										<div className="row g-3">
											<div className="col-lg-4">
												<label className="case-label">
													{t(
														"contracts.life.provinceName"
													)}
													<span>*</span>
												</label>

												<select
													className="case-input"
													name="provinceId"
													value={
														request.provinceId ||
														""
													}
													onChange={handleChange}
													required
												>
													<option value="">
														{t(
															"pleaseSelect"
														)}
													</option>

													{provinceList.map(
														(item) => (
															<option
																key={
																	item.provinceId
																}
																value={
																	item.provinceId
																}
															>
																{
																	item.provinceName
																}
															</option>
														)
													)}
												</select>
											</div>

											<div className="col-lg-4">
												<label className="case-label">
													{t(
														"contracts.life.districtName"
													)}
													<span>*</span>
												</label>

												<select
													className="case-input"
													name="districtId"
													value={
														request.districtId ||
														""
													}
													onChange={handleChange}
													required
													disabled={
														!request.provinceId
													}
												>
													<option value="">
														{t(
															"pleaseSelect"
														)}
													</option>

													{districtList.map(
														(item) => (
															<option
																key={
																	item.districtId
																}
																value={
																	item.districtId
																}
															>
																{
																	item.districtName
																}
															</option>
														)
													)}
												</select>
											</div>

											<div className="col-lg-4">
												<label className="case-label">
													{t(
														"contracts.life.village"
													)}
													<span>*</span>
												</label>

												<input
													className="case-input"
													name="village"
													value={
														request.village || ""
													}
													onChange={handleChange}
													placeholder={t(
														"contracts.life.village"
													)}
													required
												/>
											</div>

											<div className="col-lg-6">
												<label className="case-label">
													{t(
														"contracts.vehicle.accidentDate"
													)}
													<span>*</span>
												</label>

												<DatePicker
													selected={
														request.accidentDate
													}
													onChange={(date) =>
														handleDateChange(
															date,
															"accidentDate"
														)
													}
													showTimeSelect
													timeFormat="HH:mm"
													timeIntervals={15}
													dateFormat="dd/MM/yyyy HH:mm"
													className="case-input w-100"
													wrapperClassName="w-100"
													placeholderText={__t("uiText.text197")}
													required
												/>
											</div>

											<div className="col-lg-6">
												<label className="case-label">
													{t(
														"contracts.vehicle.reportAtAccidentDate"
													)}
													<span>*</span>
												</label>

												<DatePicker
													selected={
														request.reportAtAccidentDate
													}
													onChange={(date) =>
														handleDateChange(
															date,
															"reportAtAccidentDate"
														)
													}
													showTimeSelect
													timeFormat="HH:mm"
													timeIntervals={15}
													dateFormat="dd/MM/yyyy HH:mm"
													className="case-input w-100"
													wrapperClassName="w-100"
													placeholderText={__t("uiText.text198")}
													required
												/>
											</div>

											<div className="col-lg-4">
												<label className="case-label">
													{t(
														"contracts.vehicle.reportAtAccidentName"
													)}
													<span>*</span>
												</label>

												<input
													className="case-input"
													name="reportAtAccidentName"
													value={
														request.reportAtAccidentName ||
														""
													}
													onChange={handleChange}
													required
												/>
											</div>

											<div className="col-lg-4">
												<label className="case-label">
													{t(
														"contracts.vehicle.reportToPhone"
													)}
													<span>*</span>
												</label>

												<input
													type="tel"
													className="case-input"
													name="reportToPhone"
													value={
														request.reportToPhone ||
														""
													}
													onChange={handleChange}
													required
												/>
											</div>

											<div className="col-lg-4">
												<label className="case-label">
													{t(
														"contracts.vehicle.personCase"
													)}
													<span>*</span>
												</label>

												<input
													className="case-input"
													name="personCase"
													value={
														request.personCase ||
														""
													}
													onChange={handleChange}
													required
												/>
											</div>
										</div>
									</div>
								</section>

								<section className="case-section">
									<div className="case-section__header">
										<div className="case-section__icon">
											<i className="fas fa-user-shield" />
										</div>

										<div>
											<h5>{__t("uiText.text199")}</h5>
											<p>
												{__t("uiText.text200")}</p>
										</div>
									</div>

									<div className="case-section__body">
										<div className="row g-3">
											<div className="col-lg-6">
												<label className="case-label">
													{t(
														"contracts.vehicle.driverAccidentName"
													)}
													<span>*</span>
												</label>

												<input
													className="case-input"
													name="driverAccidentName"
													value={
														request.driverAccidentName ||
														""
													}
													onChange={handleChange}
													required
												/>
											</div>

											<div className="col-lg-6">
												<label className="case-label">
													{t(
														"contracts.vehicle.contactNumber"
													)}
													<span>*</span>
												</label>

												<input
													type="tel"
													className="case-input"
													name="contactNumber"
													value={
														request.contactNumber ||
														""
													}
													onChange={handleChange}
													required
												/>
											</div>

											<div className="col-12">
												<label className="case-label">
													{t(
														"contracts.vehicle.accidentNote"
													)}
												</label>

												<textarea
													className="case-textarea"
													name="accidentNote"
													rows={4}
													value={
														request.accidentNote ||
														""
													}
													onChange={handleChange}
													placeholder={__t("uiText.text201")}
												/>
											</div>

											<div className="col-12">
												<label className="case-label">
													{t(
														"contracts.vehicle.description"
													)}
												</label>

												<textarea
													className="case-textarea"
													name="description"
													rows={4}
													value={
														request.description ||
														""
													}
													onChange={handleChange}
													placeholder={__t("uiText.text202")}
												/>
											</div>
										</div>
									</div>
								</section>

								<section className="case-section">
									<div className="case-section__header case-section__header--action">
										<div className="d-flex align-items-center gap-3">
											<div className="case-section__icon">
												<i className="fas fa-car-crash" />
											</div>

											<div>
												<h5>{__t("uiText.text203")}</h5>
												<p>
													{__t("uiText.text204")}</p>
											</div>
										</div>

										<button
											type="button"
											className="case-add-button"
											onClick={addThirdPartyVehicle}
										>
											<i className="fas fa-plus" />
											{__t("uiText.text205")}</button>
									</div>

									<div className="case-section__body">
										<div className="third-party-list">
											{request.thirdPartyVehicles.map(
												(vehicle, index) => (
													<div
														className="third-party-card"
														key={vehicle.id}
													>
														<div className="third-party-card__header">
															<div>
																<span>
																	{__t("uiText.text206")}</span>
																<strong>
																	{__t("uiText.text207")}{" "}
																	{index +
																		1}
																</strong>
															</div>

															<button
																type="button"
																className="third-party-card__remove"
																onClick={() =>
																	removeThirdPartyVehicle(
																		index
																	)
																}
																title={__t("uiText.text208")}
															>
																<i className="fas fa-trash-alt" />
															</button>
														</div>

														<div className="row g-3">
															<div className="col-lg-2">
																<label className="case-label">
																	{t(
																		"contracts.vehicle.thridPartyContactNumber"
																	)}
																</label>

																<input
																	type="tel"
																	className="case-input"
																	value={
																		vehicle.contactNumber
																	}
																	onChange={(
																		event
																	) =>
																		updateThirdPartyVehicle(
																			index,
																			"contactNumber",
																			event
																				.target
																				.value
																		)
																	}
																	placeholder={__t("uiText.text209")}
																/>
															</div>

															<div className="col-lg-2">
																<label className="case-label">
																	{t(
																		"contracts.vehicle.vehicleBrand"
																	)}
																</label>

																<AsyncPaginate
																	value={
																		vehicle.vehicleBrand
																	}
																	loadOptions={
																		loadVehicleBrand
																	}
																	onChange={(
																		option
																	) =>
																		handleThirdPartyBrandChange(
																			index,
																			option
																		)
																	}
																	additional={{
																		page: 1,
																	}}
																	debounceTimeout={
																		400
																	}
																	placeholder={__t("uiText.text210")}
																	isClearable
																	styles={
																		selectStyles
																	}
																	menuPortalTarget={
																		document.body
																	}
																/>
															</div>

															<div className="col-lg-2">
																<label className="case-label">
																	{t(
																		"contracts.vehicle.vehicleModel"
																	)}
																</label>

																<input
																	className="case-input"
																	value={
																		vehicle.vehicleModel
																	}
																	onChange={(
																		event
																	) =>
																		updateThirdPartyVehicle(
																			index,
																			"vehicleModel",
																			event
																				.target
																				.value
																		)
																	}
																	placeholder={__t("uiText.text211")}
																/>
															</div>

															<div className="col-lg-2">
																<label className="case-label">
																	{t(
																		"contracts.vehicle.licensePlate"
																	)}
																</label>

																<input
																	className="case-input"
																	value={
																		vehicle.licensePlate
																	}
																	onChange={(
																		event
																	) =>
																		updateThirdPartyVehicle(
																			index,
																			"licensePlate",
																			event
																				.target
																				.value
																		)
																	}
																	placeholder={__t("uiText.text212")}
																/>
															</div>
															<div className="col-lg-3">
																<label className="case-label">
																	{t(
																		"contracts.vehicle.insurance"
																	)}
																</label>

																<input
																	className="case-input"
																	value={
																		vehicle.insurance
																	}
																	onChange={(
																		event
																	) =>
																		updateThirdPartyVehicle(
																			index,
																			"insurance",
																			event
																				.target
																				.value
																		)
																	}
																	placeholder={__t("uiText.text213")}
																/>
															</div>
														</div>
													</div>
												)
											)}
										</div>

										<button
											type="button"
											className="case-add-inline"
											onClick={addThirdPartyVehicle}
										>
											<i className="fas fa-plus-circle" />
											{__t("uiText.text214")}</button>
									</div>
								</section>

								<section className="case-section">
									<div className="case-section__header">
										<div className="case-section__icon">
											<i className="fas fa-paperclip" />
										</div>

										<div>
											<h5>{__t("uiText.text215")}</h5>
											<p>
												{__t("uiText.text216")}</p>
										</div>
									</div>

									<div className="case-section__body">
										<div className="row g-4">
											<div className="col-lg-6">
												<div className="upload-panel">
													<div className="upload-panel__title">
														<i className="fas fa-file-alt" />
														{t(
															"contracts.vehicle.documentPath"
														)}
													</div>

													<FileUploadGrid
														multiple
														folderName="caseIdiomsDocumentPathFile"
														filesFromApi={
															request.documentPath ||
															[]
														}
														onChange={(file) =>
															handleFileSelect(
																file,
																"documentPathFile"
															)
														}
														accept="image/*,application/pdf"
													/>
												</div>
											</div>

											<div className="col-lg-6">
												<div className="upload-panel">
													<div className="upload-panel__title">
														<i className="fas fa-images" />
														{t(
															"contracts.vehicle.accidentImages"
														)}
													</div>

													<FileUploadGrid
														multiple
														folderName="caseIdiomsAccidentImagesFile"
														filesFromApi={
															request.accidentImages ||
															[]
														}
														onChange={(file) =>
															handleFileSelect(
																file,
																"accidentImagesFile"
															)
														}
														accept="image/*,application/pdf"
													/>
												</div>
											</div>
										</div>
									</div>
								</section>

								<div
									className="case-submit-area"
									ref={saveButtonRef}
								>
									<button
										className="case-submit-button"
										type="submit"
										disabled={isSaving}
									>
										<i
											className={
												isSaving
													? "fas fa-spinner fa-spin"
													: "fas fa-save"
											}
										/>
										{isSaving
											? __t("uiText.text111")
											: t("button.save")}
									</button>
								</div>
							</main>

							<aside className="case-form-sidebar">
								<div className="case-summary-card">
									<div className="case-summary-card__header">
										<i className="fas fa-clipboard-check" />
										{__t("uiText.text217")}</div>

									<div className="case-summary-item">
										<span>{__t("uiText.text218")}</span>
										<strong>
											{request.contractNo || "-"}
										</strong>
									</div>

									<div className="case-summary-item">
										<span>{__t("uiText.text219")}</span>
										<strong>
											{request.vehicleInfo
												?.licensePlate || "-"}
										</strong>
									</div>

									<div className="case-summary-item">
										<span>{__t("uiText.text203")}</span>
										<strong>
											{
												request
													.thirdPartyVehicles
													.length
											}{" "}
											{__t("uiText.text220")}</strong>
									</div>

									<div className="case-summary-item">
										<span>{__t("uiText.text221")}</span>
										<strong>
											{request.carriredName || "-"}
										</strong>
									</div>
								</div>

								<div className="case-help-card">
									<i className="fas fa-info-circle" />
									<div>
										<strong>{__t("uiText.text222")}</strong>
										<p>
											{__t("uiText.text223")}</p>
									</div>
								</div>
							</aside>
						</div>
					</div>
				</section>
			</form>

			{isStickyVisible && (
				<div className="case-sticky-footer">
					<div className="case-sticky-footer__content">
						<div>
							<strong>
								{request.id
									? __t("uiText.text224")
									: __t("uiText.text225")}
							</strong>
							<span>
								{__t("uiText.text203")}{" "}
								{request.thirdPartyVehicles.length} {__t("uiText.text220")}</span>
						</div>

						<button
							type="button"
							className="case-submit-button case-submit-button--small"
							disabled={isSaving}
							onClick={() =>
								document
									.querySelector(
										".case-idioms-page form"
									)
									?.requestSubmit()
							}
						>
							<i
								className={
									isSaving
										? "fas fa-spinner fa-spin"
										: "fas fa-save"
								}
							/>
							{isSaving
								? __t("uiText.text111")
								: t("button.save")}
						</button>
					</div>
				</div>
			)}

			<CopyrightFooter />
		</div>
	);
};

export default Index;
